import styled from 'styled-components';

import StyledSelect from 'components/ui/StyledSelect';

const StyledDropdown = styled(StyledSelect)`
  display: block;
  height: 32px;
  margin-top: 0px;
`;

const StyledTextArea = styled.textarea`
  display: block;
  resize: none;
`;

const StyledLabel = styled.label`
  display: block;
  margin-top: 16px;
`;

export { StyledDropdown, StyledTextArea, StyledLabel };
